/**
 * 按命名空间包装的LocalStorage
 *
 * Example:
 *   const storage = LocalStorage.getStorage('auth');
 *   storage.setItem('token');
 *   const token = storage.getItem('token');
 *
 * @export
 * @class LocalStorage
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage(namespace) {
        this._namespace = namespace;
    }
    /**
     * 获取一个命名的存储空间
     *
     * @static
     * @param {string} namespace
     * @returns {LocalStorage}
     * @memberof LocalStorage
     */
    LocalStorage.getStorage = function (namespace) {
        var storage = LocalStorage._storages[namespace];
        if (!storage) {
            storage = new LocalStorage(namespace);
            LocalStorage._storages[namespace] = storage;
        }
        return storage;
    };
    LocalStorage.prototype.getNamespacedKey = function (key) {
        return this._namespace + ":" + key;
    };
    /**
     * 添加一对key-value
     *
     * @param {string} key
     * @param {string} val
     * @memberof LocalStorage
     */
    LocalStorage.prototype.setItem = function (key, val) {
        localStorage.setItem(this.getNamespacedKey(key), val);
    };
    /**
     * 通过key获取value
     *
     * @param {string} key
     * @returns {(string | null)}
     * @memberof LocalStorage
     */
    LocalStorage.prototype.getItem = function (key) {
        return localStorage.getItem(this.getNamespacedKey(key));
    };
    /**
     * @param  {string} key
     * @returns void
     */
    LocalStorage.prototype.removeItem = function (key) {
        localStorage.removeItem(this.getNamespacedKey(key));
    };
    LocalStorage._storages = {};
    return LocalStorage;
}());
export { LocalStorage };
//# sourceMappingURL=storage.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/storage.js
// module id = 165
// module chunks = 0